import {
    ICorp,
    navigationPermissionsDefault,
    notificationPermissionsDefault,
    restrictionsPermissionsDefault,
    WELLS_FARGO_CORP_ID,
} from "../types";

export const buildBaseCorp = (data: any = {}): ICorp => {
    const approvalEmailCC = data.restrictions?.approvalEmailCC || "";
    const cc = data.restrictions?.sendForApproval ? approvalEmailCC : "";
    const corpID = data.corpID || "";
    const isWellsFargo = corpID === WELLS_FARGO_CORP_ID;

    return {
        id: corpID,
        logo: corpID ? `/v1/corp/logo?corpID=${corpID}` : "",
        cc,
        palettes: data.palettes || [],
        morningUpdate: {
            startYear: isWellsFargo ? 2022 : 2012,
            startMonth: isWellsFargo ? 2 : 11,
        },
        permissions: {
            corpID,
            notifications: { ...notificationPermissionsDefault, ...data.notifications },
            navigation: { ...navigationPermissionsDefault, ...data.navigation },
            restrictions: {
                ...restrictionsPermissionsDefault,
                ...data.restrictions,
                hideDownloadMarketWrap: isWellsFargo,
                hideTaxLetter: isWellsFargo,
            },
        },
    };
};
